module.exports = {"540624100":"帕那镇","540624101":"强玛镇","540624102":"扎仁镇","540624103":"雁石坪镇","540624201":"多玛乡","540624202":"玛曲乡","540624205":"滩堆乡","540624207":"帮爱乡","540624209":"玛荣乡","540624210":"扎曲乡","540624211":"色务乡","540624212":"措玛乡","540624213":"岗尼乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540624.json
// module id = 2875
// module chunks = 0